import { render } from "./VolTable.vue?vue&type=template&id=3c25fa90&scoped=true"
import script from "./VolTable.vue?vue&type=script&lang=js"
export * from "./VolTable.vue?vue&type=script&lang=js"

import "./VolTable.vue?vue&type=style&index=0&id=3c25fa90&lang=less&scoped=true"
import "./VolTable.vue?vue&type=style&index=1&id=3c25fa90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c25fa90"]])

export default __exports__